<template>
  <div class="bjy-playback-userlist"></div>
</template>

<script>
import userRoleMap from './common/roleMap'

export default {
  components: {},
  data() {
    return {}
  },
  mounted() {
    BJY.UserList.create({
      element: $('.bjy-playback-userlist'),
      renderUser: function (user, width, height) {
        var imageUrl = ''
        const arr = user.avatar.split('.')
        const fileType = arr[arr.length - 1]
        imageUrl = 'https://static.51lss.com/data/img/defaultStudentPhoto.png?x-image-process=image/resize,w_40,limit_0'
        return {
          id: user.id,
          name: user.name,
          number: user.number,
          // 头像需压缩
          avatar: BJY.compressImage({
            url: imageUrl,
            width: width,
            height: height
          }),
          avatar2x: BJY.compressImage({
            url: imageUrl,
            width: width * 2,
            height: height * 2
          }),
          // 根据用户类型，配置角色的英文和本地语言
          role: userRoleMap[user.type].en,
          localRole: userRoleMap[user.type].cn
        }
      }
    })
  },
  beforeDestroy() {
  }
}
</script>

<style lang='scss'>
//@import url(); 引入公共css类
.bjy-user-list {
  position: unset;
}
</style>
